import { esc, renderInfoHelpButton, safeHref } from '../utils/formatters';
import { mpzpDesignationGroup, rgbHex } from '../layers/MpzpImportedLayer';

const EXTERNAL_ICON = '<svg width="16" height="16" aria-hidden="true" focusable="false"><use href="#icon-ext"/></svg>';
const NEW_TAB_NOTE = '<span class="sr-only"> (otwiera się w nowej karcie)</span>';
// Layers whose item symbol takes the colour of the plan layer (MpzpImportedLayer).
const PLAN_COLOUR_LAYERS = ['mpzp-ru'];

function renderLink(link, extraClass) {
    const href = safeHref(link && link.url);
    if (!href || !/^https?:/i.test(href)) return '';
    // Labels such as „Otwórz plan ogólny w Rejestrze urbanistycznym” wrap on phones instead of widening the panel.
    return '<a class="ms-button ms-button--secondary ms-button--wrap ' + (extraClass || '') + '" href="' + esc(href) + '" target="_blank" rel="noopener noreferrer">'
        + esc(link.label) + EXTERNAL_ICON + NEW_TAB_NOTE + '</a>';
}

function renderLinks(links, extraClass) {
    const html = (links || []).map((link) => renderLink(link, extraClass)).join('');
    return html ? '<div class="ms-card__actions nm-layer-point-card__actions">' + html + '</div>' : '';
}

function renderFact(fact) {
    return '<div class="ms-facts__row' + (fact.long ? ' ms-facts__row--stacked' : '') + '">'
        + '<dt class="ms-facts__label">' + esc(fact.label) + (fact.help ? renderInfoHelpButton(fact.help, 'Wyjaśnienie: ' + fact.label) : '') + '</dt>'
        + '<dd class="ms-facts__value">' + (fact.html || esc(fact.value)) + '</dd></div>';
}

/** „Kolor na mapie”: the zone's designation group with the colour the plan layer draws it in. */
function colourFact(layer, item) {
    if (PLAN_COLOUR_LAYERS.indexOf(layer) === -1 || !item.symbol) return null;
    const group = mpzpDesignationGroup(item.symbol);
    if (!group) return null;
    return {
        label: 'Kolor na mapie',
        help: 'Kolor grupy przeznaczenia na mapie Metroskopu'
            + '\nObliczenie: Metroskop przypisuje każdy symbol terenu z planu do jednej grupy legendy. Symbole grupy „' + group.label + '”: ' + group.symbols.join(', ') + '.'
            + '\nUwaga: kolor ułatwia odnalezienie terenu na mapie. Obowiązujące przeznaczenie podają tekst i rysunek planu.',
        html: '<i class="ms-map-legend__swatch ms-map-legend__swatch--area nm-layer-point-card__swatch" style="--legend-color: ' + esc(rgbHex(group.rgb)) + '" aria-hidden="true"></i>'
            + esc(group.label),
    };
}

function renderItem(layer, item) {
    const facts = [colourFact(layer, item)].concat(item.facts || []).filter(Boolean);
    return '<section class="nm-layer-point-card__item">'
        + '<div class="ms-card__heading">'
        + '<div class="nm-layer-point-card__title-row"><h4 class="ms-card__title">' + esc(item.title)
        + (item.help ? ' ' + renderInfoHelpButton(item.help, 'Wyjaśnienie: ' + item.title) : '') + '</h4>'
        + (item.badge ? '<span class="ms-badge ms-badge--' + esc(item.badge.tone || 'neutral') + '">' + esc(item.badge.label) + '</span>' : '')
        + '</div>'
        + (item.subtitle ? '<p class="ms-card__subtitle nm-layer-point-card__subtitle">' + esc(item.subtitle) + '</p>' : '')
        + '</div>'
        + (facts.length ? '<dl class="ms-facts">' + facts.map(renderFact).join('') + '</dl>' : '')
        + renderLinks(item.links, 'ms-button--sm')
        + '</section>';
}

/**
 * The answer of one overlay layer (LayerPointResult.php, or a link-only layer of
 * layer-point-sources.js) under its section heading in the point panel: a card with what the
 * layer shows at the point, or a note that its source has nothing there, with the source link.
 */
export function renderLayerPointCard(data) {
    const layer = data && data.layer ? String(data.layer) : '';
    if (!data || data.status !== 'found' || !(data.items || []).length) {
        return '<div class="ms-note nm-layer-point-note" data-layer-point-card="' + esc(layer) + '" data-layer-point-status="' + esc(data && data.status || 'none') + '">'
            + '<p>' + esc(data && data.message || 'Brak danych tej warstwy dla wybranego miejsca.')
            + (data && data.help ? ' ' + renderInfoHelpButton(data.help, data.status === 'external' ? 'Wyjaśnienie źródła' : 'Wyjaśnienie braku danych') : '') + '</p>'
            + (data && data.links || []).map((link) => renderLink(link, 'ms-button--sm')).join('')
            + (data && data.source ? '<p class="ms-note__meta">' + esc(data.source) + '</p>' : '')
            + '</div>';
    }

    return '<article class="ms-card ms-dept--environment nm-layer-point-card" data-layer-point-card="' + esc(layer) + '" data-layer-point-status="found">'
        + '<div class="ms-card__body ms-card__content">'
        + data.items.map((item) => renderItem(layer, item)).join('')
        + (data.source ? '<p class="ms-card__meta">' + esc(data.source) + '</p>' : '')
        + renderLinks(data.links, 'ms-button--block')
        + '</div></article>';
}
